import { render, staticRenderFns } from "./RecebimentoForm.vue?vue&type=template&id=31c02b7b"
import script from "./RecebimentoForm.vue?vue&type=script&lang=js"
export * from "./RecebimentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports